// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

const { default: axios } = require("axios");
require("fslightbox");

// import styles bundle
import 'swiper/css/bundle';

const SwiperGalleries = function () {

    //galeria apartamentos
    const galleryViewDinamic = (slide) => {

        console.log('load');

        const galVDinamic = ".swipper-view-dinamic";
        if($(galVDinamic).length <= 0) return;

        $(galVDinamic).each(function(i,e){

            // console.log($(this).attr('data-loop'));
            let swiperHoriz = new Swiper(e, {
                effect: "slide",                
                speed:1000,
                loop: false,
                createElements: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                // breakpoints: {
                //     992: {
                //         slidesPerView: parseInt(perView),
                //         spaceBetween: 30,
                //     },
                // }
            });

            if(slide){
                swiperHoriz.slideTo(slide, 2000);
            }

            swiperHoriz.update();
        });


    }

    //galeria horiz overflow
    const galleryHorz = () => {

        const galHoriz = "#swiper-horiz";
        if($(galHoriz).length <= 0) return;

        const swiperHoriz = new Swiper(galHoriz, {
            // cssMode     : true,
            speed       : 1500,
            loop        : false,
            effect      : 'slide',
            autoplay    : false,
            centeredSlides: true,
            slidesPerView: 1,//
            spaceBetween: 30,
            pagination  : {
                el: '#swiper-pagination-horiz',
                type : 'custom',
                renderCustom: function (swiper, current, total) {
                    return '<span class="swiper-pagination-current-custom">'+current + '</span> | ' + total;
                    }
                /* clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "</span>";
                }, */
                },
                navigation: {
                    prevEl: "#swiper-horiz-button-prev",
                    nextEl: "#swiper-horiz-button-next",
                },
                breakpoints: {
                    768: {
                        slidesPerView: "auto",//
                        centeredSlides: false,
                    }
                }
        });
    }

    const buyGalChoose = (e) => {

        const _this = $(e.currentTarget);
        const _colorSelected = _this.data('color');
       
        // gal choosed
        $('.choosed-gallery').removeClass('active');
        $('#choosed-gallery-'+_colorSelected).addClass('active');

    }

    const goSlideGal = (e) => {
        const _this = $(e.currentTarget);
        const slideTo = $(_this).attr('data-goslide')
        galleryViewDinamic(slideTo);
    }


    return {

        galleryViewDinamic : galleryViewDinamic,

        init : () => {
            galleryViewDinamic();
            galleryHorz();

            $(document).on('click', '.buy-choose-gallery', buyGalChoose);
            $(document).on('click', '.goSlideGal', goSlideGal);

        }
    }

}();

export default SwiperGalleries;
